import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { checkoutStepDefinition } from "../CheckoutPage/CheckoutStartup";
import { searchFlowStepDefinition } from "../Common/Search/SearchStartup";
import { selectOfferStepDefinition } from "../TrainOfferPage/SelectOfferFlow/SelectOfferStartupFlow";
import { ticketOptionMainStepDefinition } from "../TrainOfferPage/TicketOptionFlow/TicketOptionStartupFlow";
import { mainBookingInitStepDeclaration } from "./Steps/MainBookingInit";
import { MainBookingSearchTransition } from "./Transition/MainBookingSearchTransition";
import { MainBookingSelectOfferTransition } from "./Transition/MainBookingSelectOfferTransition";
import { MainBookingTicketOptionTransition } from "./Transition/MainBookingTicketOptionTransition";
import { MainBookingTransition } from "./Transition/MainBookingTransition";


export const mainBookingStartupFlow = new FlowDefinition("MainBookingFlow");

mainBookingStartupFlow.addStep(mainBookingInitStepDeclaration);
mainBookingStartupFlow.addStep(searchFlowStepDefinition);

mainBookingStartupFlow.addStep(selectOfferStepDefinition);
mainBookingStartupFlow.addStep(ticketOptionMainStepDefinition);

mainBookingStartupFlow.addStep(checkoutStepDefinition);

mainBookingStartupFlow.addLink("MainBookingInit_Step", "SearchFlow");
mainBookingStartupFlow.addLink("MainBookingInit_Step", "SelectOfferFlow");
mainBookingStartupFlow.addLink("MainBookingInit_Step", "TicketOptionFlow");

//This is because, from Home search click to start SelectOfferFlow and TicketOptionFlow both
mainBookingStartupFlow.addLink("SearchFlow", "SelectOfferFlow");
mainBookingStartupFlow.addLink("SearchFlow", "TicketOptionFlow");

//This is because, If modified search click close then again start SelectOfferFlow
mainBookingStartupFlow.addLink("SelectOfferFlow", "SearchFlow");

//This is because, from TicketOptionFlow we need to start CheckoutFlow for Normal booking flow.
mainBookingStartupFlow.addLink("TicketOptionFlow", "CheckoutFlow");

//This is because, When we have Round Trip - Need to again start SelectOfferFlow and TicketOptionFlow from TicketOptionFlow
mainBookingStartupFlow.addLink("TicketOptionFlow", "SelectOfferFlow");
mainBookingStartupFlow.addLink("TicketOptionFlow", "TicketOptionFlow");

//This is because, from SelectOfferFlow we need to start CheckoutFlow for Direct shuttle booking.
mainBookingStartupFlow.addLink("SelectOfferFlow", "CheckoutFlow");

mainBookingStartupFlow.addTransition(MainBookingTransition, "MainBookingInit_Step");
mainBookingStartupFlow.addTransition(MainBookingSearchTransition, "SearchFlow");
mainBookingStartupFlow.addTransition(MainBookingSelectOfferTransition, "SelectOfferFlow");
mainBookingStartupFlow.addTransition(MainBookingTicketOptionTransition, "TicketOptionFlow");

mainBookingStartupFlow.setStartStep("MainBookingInit_Step");

export const mainBookingStepDefinition = new StepDefinition({
    stepName: "MainBookingFlow",
    stepFlow: mainBookingStartupFlow,
    contextIsolation: false
})
